export interface ServiceWorkerConfig {
  enabled: boolean;
  cacheEnabled: boolean;
  cacheName: string;
  urlsToCache: string[];
  updateInterval: number;
  skipWaiting: boolean;
  clientsClaim: boolean;
}

const config: ServiceWorkerConfig = {
  enabled: /* @SW_ENABLED */ true /* @SW_ENABLED_END */,
  cacheEnabled: /* @SW_CACHE_ENABLED */ true /* @SW_CACHE_ENABLED_END */,
  cacheName: 'planet-home-healthcare-v1',
  urlsToCache: [
    '/',
    '/index.html',
    '/manifest.json',
    '/icons/favicon.ico',
    '/icons/main-logo2.svg',
    '/icons/apple-touch-icon.png',
    '/icons/favicon-96x96.png',
    '/icons/android-chrome-192x192.png',
    '/icons/android-chrome-512x512.png'
  ],
  updateInterval: 60 * 60 * 1000, // 1 hour
  skipWaiting: true,
  clientsClaim: true
};

export default config; 